import React from 'react'
import { connect } from 'react-redux'
import { fetchCommunityNoticesIfNeeded } from '~/community/actions'


class Notices extends React.Component{

  componentWillMount(){
    const { dispatch } = this.props
    dispatch(fetchCommunityNoticesIfNeeded())
  }

  render() {
    const { communityNotices } = this.props

    return (
      <div>
      { communityNotices.items.map((item, index) => (
        <div>
          <h3>{ item.title[0].value }</h3>
          { item.field_comm_notice_teaser.length > 0 && <div style={{fontWeight: 'bold'}} dangerouslySetInnerHTML={{ __html: item.field_comm_notice_teaser[0].value }} /> }

          <div dangerouslySetInnerHTML={{ __html: item.body[0].value }} />
        </div>
      ))}
      </div>
    )
  }
}
export default connect(state => ( { communityNotices: state.communityNotices })) (Notices)
